/** A cached low-frequency noise buffer, played through the existing audio context. */
export class Thunder {
    private buffer?: AudioBuffer
    private source?: AudioBufferSourceNode
    private gain?: GainNode
    play = (context: AudioContext, destination: AudioNode, volume: number) => {
        if (context.state !== "running") return
        this.stop()
        if (!this.buffer) {
            this.buffer = context.createBuffer(1, 48000, 16000)
            const data = this.buffer.getChannelData(0)
            let low = 0
            for (let i = 0; i < data.length; i++) {
                low = low * 0.94 + (Math.random() * 2 - 1) * 0.06
                data[i] = low * 4 * Math.exp(-i / 18000)
            }
        }
        const source = context.createBufferSource()
        const gain = context.createGain()
        source.buffer = this.buffer
        gain.gain.setValueAtTime(0, context.currentTime)
        gain.gain.linearRampToValueAtTime(volume, context.currentTime + 0.08)
        gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 3)
        source.connect(gain); gain.connect(destination)
        source.onended = () => { source.disconnect(); gain.disconnect(); if (this.source === source) this.source = undefined }
        this.source = source; this.gain = gain
        source.start()
    }
    stop = () => { this.source?.stop(); this.source = undefined; this.gain?.disconnect(); this.gain = undefined }
}
